"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./index";

export type AppTooltipProps = {
  title: React.ReactNode;
  children: React.ReactElement;
  side?: React.ComponentProps<typeof TooltipContent>["side"];
  align?: React.ComponentProps<typeof TooltipContent>["align"];
  sideOffset?: number;
  delayDuration?: number;
  contentClassName?: string;
};

function isDisabledElement(child: React.ReactElement): boolean {
  const props = child.props as { disabled?: unknown };
  return props.disabled === true;
}

export function AppTooltip({
  title,
  children,
  side,
  align,
  sideOffset = 6,
  delayDuration = 120,
  contentClassName,
}: AppTooltipProps) {
  if (title === null || title === undefined || title === "") {
    return children;
  }

  const triggerChild = isDisabledElement(children) ? (
    <span className="inline-flex">{children}</span>
  ) : (
    children
  );

  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{triggerChild}</TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          sideOffset={sideOffset}
          className={cn(contentClassName)}
        >
          {typeof title === "string" ? <p>{title}</p> : title}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

AppTooltip.displayName = "AppTooltip";
